import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import React, { useEffect, useMemo } from 'react';
import { api } from 'careand-redux/api/ApiThunks';
import CalendarUtils from 'services/CalendarUtils';
import moment from 'moment-timezone';
import PerformanceUtils from 'services/PerformanceUtils';
import PhysicianCalendars from 'scenes/HomeStaff/AdminLargeSchedule/PhysicianCalendars';

const CalendarView = ({
  isCalendarVisible,
  date,
  selectPhysician,
  physicians,
  setTimeAndDate,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const allShifts = useAppSelector((state) => state.shifts.shifts);

  useEffect(() => {
    dispatch(api.Appointments.getDayAppointments({ clinicId: props.clinic_id, date }));
    dispatch(api.Shifts.getDayShifts({ clinicId: props.clinic_id, date }));
  }, [date, dispatch, props.clinic_id]);

  const shifts = useMemo(
    () => CalendarUtils.filterShifts(allShifts, moment.unix(date), props.clinic_id),
    [allShifts, date, props.clinic_id],
  );

  const physicianArray = useMemo(() => {
    let result = PerformanceUtils.objectToArray(physicians);
    return result.filter((physician) => {
      return !!shifts.find((shift) => shift.user_id === physician.id);
    });
  }, [physicians, shifts]);

  return (
    isCalendarVisible && (
      <div className="calendar-view scroll-list">
        <PhysicianCalendars
          clinicId={props.clinic_id}
          physicians={physicianArray}
          date={moment.unix(date)}
          showCancelled={false}
          showActualTime={false}
          onSelectSlot={(physician, slot) => {
            if (slot?.start) {
              let startTime = CalendarUtils.convertToTargetTimezone(slot.start);
              setTimeAndDate(startTime);
            }
            if (physician) selectPhysician(physician.id);
          }}
          disableDragNDrop={true}
          shifts={shifts}
        />
      </div>
    )
  );
};

export default CalendarView;
